import api from './api';

export const extractDataset = (payload) => api.post('/api/pipeline/extract', payload);
export const getExports = (params) => api.get('/api/pipeline/exports', { params });
export const getExportById = (id) => api.get(`/api/pipeline/exports/${id}`);
